/**
 * Human-readable Czech labels for audit log action and entity type values.
 *
 * Keep in sync with internal/auth/actions.go.
 * When adding a new Action or EntityType constant there, add the label here.
 * ENTITY_TYPE_OPTIONS is derived automatically — no manual update needed.
 */

export const ACTION_LABELS: Record<string, string> = {
  // Auth
  "auth.login.success": "Přihlášení",
  "auth.login.failure": "Neúspěšné přihlášení",
  "auth.logout": "Odhlášení",

  // User
  "user.created": "Vytvoření uživatele",
  "user.updated": "Úprava uživatele",
  "user.password.changed": "Změna hesla",
  "user.password.reset": "Reset hesla",

  // Category
  "category.created": "Vytvoření kategorie",
  "category.updated": "Úprava kategorie",
  "category.deleted": "Smazání kategorie",

  // Item
  "item.created": "Vytvoření položky",
  "item.updated": "Úprava položky",
  "item.deleted": "Smazání položky",

  // Note
  "note.created": "Vytvoření poznámky",
  "note.updated": "Úprava poznámky",
  "note.deleted": "Smazání poznámky",
};

export const ENTITY_TYPE_LABELS: Record<string, string> = {
  user: "Uživatel",
  session: "Relace",
  category: "Kategorie",
  item: "Položka",
  note: "Poznámka",
};

/** Options for the entity-type filter <Select>. Derived automatically. */
export const ENTITY_TYPE_OPTIONS: { value: string; label: string }[] = [
  { value: "", label: "Všechny" },
  ...Object.entries(ENTITY_TYPE_LABELS)
    .sort((a, b) => a[1].localeCompare(b[1], "cs"))
    .map(([value, label]) => ({ value, label })),
];

export function labelAction(action: string): string {
  return ACTION_LABELS[action] ?? action;
}

export function labelEntityType(entityType: string): string {
  return ENTITY_TYPE_LABELS[entityType] ?? entityType;
}
